import { InventoryService } from '../services/inventoryService';
import type { InventoryItem } from '../services/stepSummaryHtml';

export async function loadStepFourInventories(): Promise<{
  resentments: InventoryItem[];
  fears: InventoryItem[];
  harms: InventoryItem[];
}> {
  const types = ['resentments', 'fears', 'harms'] as const;
  const result: Record<(typeof types)[number], InventoryItem[]> = {
    resentments: [],
    fears: [],
    harms: [],
  };

  await Promise.all(
    types.map(async (type) => {
      try {
        const versions = await InventoryService.listInventoryVersions(type);
        const versionKey = versions.length > 0 ? versions[0] : '';
        if (!versionKey) return;
        const items = await InventoryService.getInventory(type, versionKey);
        result[type] = items.filter((item) => item._type !== 'completion_status');
      } catch {
        result[type] = [];
      }
    })
  );

  return result;
}

export async function loadAmendsPersons(inventoryKey: 'step8-persons' | 'step9-persons') {
  try {
    const items = await InventoryService.getInventory(inventoryKey, 'default');
    return items
      .filter((item) => item != null && typeof item === 'object' && item._type !== 'completion_status')
      .map((item) => ({
        name: item.name || '',
        note: item.note || '',
        timing: item.timing || '',
        form: item.form || '',
        amendsPlan: item.amendsPlan || '',
        amendsCompleted: item.amendsCompleted,
        amendsExperience: item.amendsExperience || '',
      }));
  } catch {
    return [];
  }
}

export async function loadStep10Inventories() {
  try {
    const items = await InventoryService.getInventory('step10-inventories', 'default');
    return items
      .filter((item) => item != null && typeof item === 'object' && item._type !== 'completion_status')
      .map((item) => ({
        date: item.date || '',
        note: item.note || '',
      }));
  } catch {
    return [];
  }
}
